module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="quick-view';
if(isGroup){;
__p += ' group';
};
__p += '">\n    <div class="project-container">\n        ';
 if (isInProject) { ;
__p += '\n            <label>Project:</label>\n            ';
 if (projectContext) { ;
__p += '\n                <span>' +
__e( projectName ) +
'</span>\n            ';
 } else { ;
__p += '\n                <a href="' +
__e( projectDashboardUrl ) +
'" class="project-url">' +
__e( projectName ) +
'</a>\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n    </div>\n\n    ';
 if (isGroup) { ;
__p += '\n        <div class="group-name editable-group-container">\n            <div contenteditable="' +
__e(!spectatorMode) +
'" class="editable edit-group-name';
if(spectatorMode){;
__p += ' disabled';
};
__p += '" ';
if(spectatorMode){;
__p += 'disabled';
};
__p += '>\n            </div>\n        </div>\n\n        <div class="select-experience-variant">\n            <ul class="variant-tabs tab-menu';
 if (entries.length > 7) {;
__p += ' small';
};
__p += ' ' +
__e(groupType ) +
'">\n            ';
 _.each(entries, function (entry, index) {
                var identifier = entry[1] ? entry[1].getIdentifier() : "";
                ;
__p += '\n                <li class="variant-tab" data-experience="' +
__e( entry[0].id ) +
'">\n                    <div class="variant-icon ' +
__e(identifier);
 if (entries.length > 7) {;
__p += ' small';
};
__p += '">#' +
__e( index + 1 ) +
'</div>\n                </li>\n            ';
 }); ;
__p += '\n            </ul>\n        </div>\n    ';
 } ;
__p += '\n<div class="experience-details-region"></div>\n<div class="group-details-region"></div>\n<div class="sharing-area"></div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experienceOverview/QuickView.tpl
// module id = 2886
// module chunks = 0